import { render, staticRenderFns } from "./LotteryNotice.vue?vue&type=template&id=ead64894&scoped=true&"
import script from "./LotteryNotice.vue?vue&type=script&lang=ts&"
export * from "./LotteryNotice.vue?vue&type=script&lang=ts&"
import style0 from "./LotteryNotice.vue?vue&type=style&index=0&id=ead64894&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead64894",
  null
  
)

export default component.exports